// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__pojVS","pending_approval":"_styles_pending_approval__rEpNn","mob_job_list":"_styles_mob_job_list__sdO3Y"};